import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// Import VueI18n instance with options
// import i18n from '@/plugins/i18n'

Vue.use(Vuetify)

const MY_ICONS = {
  menu: 'menu',
  expand: 'keyboard_arrow_down',
  dropdown: 'keyboard_arrow_down'
}

export default new Vuetify({
  // lang: {
  //   t: (key, ...params) => i18n.t(key, params)
  // },
  icons: {
    iconfont: 'fa',
    values: MY_ICONS
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
      minifyTheme: function (css) {
        return process.env.NODE_ENV === 'production'
          ? css.replace(/[\r\n|\r|\n]/g, '')
          : css
      }
    },
    themes: {
      light: {
        // Background colors
        kbDarkBlue: '#172B4D',
        kbLight: '#F0F4FD',
        kbLightGray: '#f2f2f2',
        kbSemiLightGray: '#8898AA',
        kbWhite: '#FFFFFF',
        // Buttons
        mainButtons: '#7764E4',
        // Text colors
        kbDarkBlueText: '#172B4D',
        kbDarkText: '#4D4F5C',
        kbGrayText: '#707070',
        kbSemiDarkBlueText: '#163974',
        kbSemiLightGrayText: '#8898AA', // Este es el mismo que Gray
        primary: '#657B7D',
        secondary: '#243C54',
        accent: '#2A697B',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        cremita: '#F3DFCA',
        facebook: '#3B5998',
        google: '#DB4437',
        instagram: '#f09433',
        spotify: '#4CAF50',
        email: '#ff695e',
        phone: '#4f8e62',
        total: '#1a237e',
        imported: '#1a237e',
        money: '#6e8e6b',
        ctLightBlue: '#90C1FB',
        kbOrange: '#FB6340',
        kbGreen: '#2DCE98',
        kbLightBlue: '#11CDEF',
        kbDark: '#4D4F5C',
        kbGray: '#8898AA',
        kbPink: '#F66277',
        kbBlue: '#4279D6',
        kbSemiDarkBlue: '#163974',
        kbRed: '#F53C56',
        kbPurple: '#7764E4',
        kbGold: '#FBB644',
        kbGrayLightText: '#c4c4c4',
        kbTableHeaders: '#8598ac',
        abadPrimary: '#c21d24',
        kbSemiExtraLightGray: '#D9DADB'
      },
      dark: {
        // Background colors
        kbDarkBlue: '#172B4D',
        kbDarkGray: '#646673',
        kbLight: '#14192A',
        kbLightGray: '#f2f2f2',
        kbSemiLightGray: '#8898AA',
        kbWhite: '#1F263C',
        // Buttons
        mainButtons: '#fb903c',
        // Text colors
        kbDarkBlueText: '#FFFFFF',
        kbDarkText: '#FFFFFF',
        kbGrayText: '#FFFFFF',
        kbSemiDarkBlueText: '#FFFFFF',
        kbSemiLightGrayText: '#C4C4C4',
        primary: '#657B7D',
        secondary: '#243C54',
        accent: '#2A697B',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        cremita: '#F3DFCA',
        facebook: '#3B5998',
        google: '#DB4437',
        instagram: '#f09433',
        spotify: '#4CAF50',
        email: '#ff695e',
        phone: '#4f8e62',
        total: '#1a237e',
        imported: '#1a237e',
        money: '#6e8e6b',
        ctLightBlue: '#90C1FB',
        kbOrange: '#FB6340',
        kbGreen: '#2DCE98',
        kbLightBlue: '#11CDEF',
        kbDark: '#4D4F5C',
        kbGray: '#8898AA',
        kbPink: '#F66277',
        kbBlue: '#4279D6',
        kbSemiDarkBlue: '#163974',
        kbRed: '#F53C56',
        kbPurple: '#7764E4',
        kbGold: '#FBB644',
        kbGrayLightText: '#c4c4c4',
        kbTableHeaders: '#8598ac',
        abadPrimary: '#c21d24',
        kbSemiExtraLightGray: '#D9DADB'
      }
    }
  }
})
